module.exports = "<highcharts-chart \n[Highcharts]=\"Highcharts\"\n[options]=\"chartData\"\nstyle=\"width: 100%; height: 400px; display: block;\"\n></highcharts-chart>\n"


//////////////////
// WEBPACK FOOTER
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/users/bar/bar.component.html
// module id = ../../../../../src/app/users/bar/bar.component.html
// module chunks = main